/* ===== OMW! Shopify theme interactions =====
   - Buy box: flavor = product, pack = variant. Adds the real variant to the
     Shopify cart via /cart/add.js, then refreshes the cart count.
   - Scroll reveal, newsletter toast, cart-count badge.
   Reads config from window.OMW (money format, routes) injected in theme.liquid,
   and per-section product data from the buybox JSON island.
*/
(function () {
  "use strict";

  var OMW = window.OMW || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Money (Shopify-style) ---- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var fmt = format || OMW.moneyFormat || "${{amount}}";
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, d) { return (typeof n === "undefined" || n === null) ? d : n; }
    function thousands(num, precision, thousandsSep, decimalSep) {
      precision = defaultTo(precision, 2);
      thousandsSep = defaultTo(thousandsSep, ",");
      decimalSep = defaultTo(decimalSep, ".");
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousandsSep);
      var cents = parts[1] ? decimalSep + parts[1] : "";
      return dollars + cents;
    }
    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case "amount": value = thousands(cents, 2); break;
      case "amount_no_decimals": value = thousands(cents, 0); break;
      case "amount_with_comma_separator": value = thousands(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = thousands(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = thousands(cents, 2, " ", ","); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  /* ---- Toast ---- */
  var toast = $("#toast");
  var toastMsg = $("#toastMsg");
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (toastMsg) toastMsg.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 2800);
  }

  /* ---- Cart count badge ---- */
  function setCartCount(n) {
    $$(".cart-btn .count, [data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.animate(
        [{ transform: "scale(1)" }, { transform: "scale(1.5)" }, { transform: "scale(1)" }],
        { duration: 360, easing: "ease-out" }
      );
    });
  }
  function refreshCartCount() {
    fetch((OMW.routes && OMW.routes.cart) ? OMW.routes.cart + ".js" : "/cart.js", {
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }

  /* ---- Buy box ---- */
  function initBuybox(scope) {
    var box = (scope && scope.querySelector && scope.querySelector("#omw-buybox")) || $("#omw-buybox");
    if (!box || box.__omwInit) return;
    box.__omwInit = true;
    var dataEl = $("#omw-buybox-data");
    var flavors;
    try { flavors = JSON.parse(dataEl.textContent).flavors || []; }
    catch (e) { flavors = []; }
    if (!flavors.length) return;

    var state = { fi: 0, sel: [] };

    var titleEl = $("#bbTitle", box);
    var mascotEl = $("#bbMascot", box);
    var priceEl = $("#bbPrice", box);
    var eaEl = $("#bbEa", box);
    var descEl = $("#bbDesc", box);
    var addPriceEl = $("#addPrice", box);
    var addBtn = $("#addBtn", box);
    var wasEl = $("#bbWas", box);
    var shopPouch = $("#shopPouch", box);
    var blobEl = $("#shopBlob", box);
    var optionRows = $("#optionRows", box);
    var flavorRow = $("#flavorRow", box);

    function activeFlavor() { return flavors[state.fi]; }
    function optsOf(v) { return v.opts || (v.title ? [v.title] : []); }
    function optionNames() {
      var f = activeFlavor();
      return (f.options && f.options.length) ? f.options : ["Size", "Pack"];
    }
    // variant that results from choosing `val` at option `idx`, holding other selections
    function variantWith(idx, val) {
      return activeFlavor().variants.filter(function (v) {
        if (optsOf(v)[idx] !== val) return false;
        for (var j = 0; j < state.sel.length; j++) {
          if (j !== idx && optsOf(v)[j] !== state.sel[j]) return false;
        }
        return true;
      })[0] || null;
    }
    // pouches in a variant = largest integer across its option values / title (8-pack -> 8)
    function packCount(v) {
      var n = 0;
      optsOf(v).concat([v.title || ""]).forEach(function (val) {
        var p = parseInt(val, 10); if (p > n) n = p;
      });
      return n;
    }
    function currentVariant() {
      return activeFlavor().variants.filter(function (v) {
        return optsOf(v).every(function (val, i) { return state.sel[i] === val; });
      })[0] || null;
    }
    function distinctVals(idx) {
      var seen = [];
      activeFlavor().variants.forEach(function (v) {
        var val = optsOf(v)[idx];
        if (val != null && seen.indexOf(val) < 0) seen.push(val);
      });
      return seen;
    }
    // is there an available variant with option[idx]=val while holding the other selections?
    function comboAvailable(idx, val) {
      return activeFlavor().variants.some(function (v) {
        if (optsOf(v)[idx] !== val) return false;
        for (var j = 0; j < state.sel.length; j++) {
          if (j !== idx && optsOf(v)[j] !== state.sel[j]) return false;
        }
        return v.available;
      });
    }

    function renderOptions() {
      optionRows.innerHTML = "";
      optionNames().forEach(function (name, idx) {
        var isSize = /size/i.test(name);
        var isPack = /pack/i.test(name);
        var label = document.createElement("p");
        label.className = "opt-label";
        label.innerHTML = isPack
          ? name + ' <span class="hand" style="color:var(--berry);font-size:1.15rem">save more →</span>'
          : name;
        optionRows.appendChild(label);
        var row = document.createElement("div");
        row.className = isSize ? "seg-row" : (isPack ? "pack-row pack-row--2" : "pack-row");
        distinctVals(idx).forEach(function (val) {
          var btn = document.createElement("button");
          var active = state.sel[idx] === val;
          btn.setAttribute("data-opt", idx);
          btn.setAttribute("data-val", val);
          if (!comboAvailable(idx, val)) btn.setAttribute("disabled", "");
          if (isSize) {
            btn.className = "seg" + (active ? " is-active" : "");
            btn.innerHTML = "<b>" + val + "</b>";
          } else {
            btn.className = "pack" + (active ? " is-active" : "");
            var vv = variantWith(idx, val);
            var html = "";
            if (isPack && vv && vv.compare > vv.price) {
              html += '<span class="pack__badge">Save ' + Math.round((1 - vv.price / vv.compare) * 100) + "%</span>";
            }
            html += '<div class="pack__size">' + val + "</div>";
            if (vv) { var pc = packCount(vv); if (pc) html += '<div class="pack__ea">' + formatMoney(Math.round(vv.price / pc)) + " ea</div>"; }
            btn.innerHTML = html;
          }
          row.appendChild(btn);
        });
        optionRows.appendChild(row);
      });
    }

    function render() {
      var f = activeFlavor();
      var v = currentVariant() || f.variants[0];
      if (titleEl) titleEl.textContent = f.title;
      if (mascotEl) {
        var ms = (f.mascots || (f.mascot ? [f.mascot] : [])).filter(Boolean);
        mascotEl.textContent = ms.length
          ? "say hi to " + ms.map(function (m) { return "“" + m + "”"; }).join(" & ")
          : "";
      }
      if (descEl) descEl.innerHTML = f.desc || "";
      var c = packCount(v);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (wasEl) {
        if (v.compare && v.compare > v.price) { wasEl.textContent = formatMoney(v.compare); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (eaEl) eaEl.textContent = c ? formatMoney(Math.round(v.price / c)) + " per pouch" : "";
      if (addPriceEl) addPriceEl.textContent = formatMoney(v.price);
      if (addBtn && addBtn.childNodes[0]) {
        addBtn.toggleAttribute("disabled", !v.available);
        addBtn.childNodes[0].textContent = v.available ? "Add to bag · " : "Sold out · ";
      }
      if (shopPouch) {
        var imgs = (f.images && f.images.length) ? f.images : (f.image ? [f.image] : []);
        shopPouch.className = "shop__pouches" + (imgs.length > 1 ? " is-duo" : "");
        shopPouch.innerHTML = imgs.map(function (src) {
          return '<img src="' + src + '" alt="OMW! ' + f.title + '" width="1100" height="1189">';
        }).join("");
      }
      if (blobEl && f.accent) {
        blobEl.style.background = "radial-gradient(circle at 38% 32%, rgba(255,255,255,.6), " + f.accent + ")";
      }
      $$(".ftile", flavorRow).forEach(function (b, i) { b.classList.toggle("is-active", i === state.fi); });
    }

    function selectFirstAvailable() {
      var f = activeFlavor();
      var v = f.variants.filter(function (x) { return x.available; })[0] || f.variants[0];
      state.sel = optsOf(v).slice();
    }

    function setFlavor(i) {
      if (i < 0 || i >= flavors.length) return;
      state.fi = i;
      selectFirstAvailable();
      renderOptions();
      render();
      buildGallery();
    }

    // flavor tiles (rendered by Liquid)
    if (flavorRow) {
      flavorRow.addEventListener("click", function (e) {
        var t = e.target.closest(".ftile");
        if (!t) return;
        setFlavor(parseInt(t.getAttribute("data-fi"), 10) || 0);
      });
    }
    // option buttons (rendered by JS)
    optionRows.addEventListener("click", function (e) {
      var t = e.target.closest(".seg, .pack");
      if (!t || t.hasAttribute("disabled")) return;
      var idx = parseInt(t.getAttribute("data-opt"), 10) || 0;
      state.sel[idx] = t.getAttribute("data-val");
      // if that combo has no variant, snap the other options to a valid one
      if (!currentVariant()) {
        var f = activeFlavor();
        var alt = f.variants.filter(function (v) { return optsOf(v)[idx] === state.sel[idx] && v.available; })[0]
               || f.variants.filter(function (v) { return optsOf(v)[idx] === state.sel[idx]; })[0];
        if (alt) state.sel = optsOf(alt).slice();
      }
      renderOptions();
      render();
    });

    // lineup cards / any element with data-shop-flavor preselects a flavor
    $$("[data-shop-flavor]").forEach(function (el) {
      el.addEventListener("click", function () {
        var key = el.getAttribute("data-shop-flavor");
        var idx = flavors.findIndex(function (f) { return f.key === key; });
        if (idx >= 0) {
          setFlavor(idx);
          box.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    // add to cart
    addBtn.addEventListener("click", function () {
      var v = currentVariant();
      if (!v || !v.available) return;
      if (!v.id) {
        showToast("Connect this pouch to a product in the theme editor to enable checkout.");
        return;
      }
      addBtn.setAttribute("disabled", "");
      fetch((OMW.routes && OMW.routes.cartAdd) ? OMW.routes.cartAdd : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          addBtn.removeAttribute("disabled");
          showToast(activeFlavor().title + " · " + v.title + " added!");
          refreshCartCount();
        })
        .catch(function () {
          addBtn.removeAttribute("disabled");
          showToast("Sorry — couldn't add that. Try again.");
        });
    });

    /* ---- Per-product gallery views + enlarge lightbox ---- */
    var stageEl = $("#shopStage", box);
    var thumbsEl = $("#shopThumbs", box);
    var GAL_LABELS = ["Front", "Back", "Label"];
    var GAL_ICONS = [
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2h8l-1 4v2l2 3v9a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-9l2-3V6z"></path><path d="M9 6h6"></path></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><path d="m3.3 7 8.7 5 8.7-5M12 22V12"></path></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="2"></rect><path d="M8 7h8M8 11h8M8 15h5"></path></svg>'
    ];
    var GAL_ICON_DEFAULT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><path d="m21 15-5-5L5 21"></path></svg>';
    function setView(id) {
      $$(".shop__thumb", box).forEach(function (t) { t.classList.toggle("is-on", t.getAttribute("data-view") === id); });
      $$(".shop__view", box).forEach(function (v) { v.classList.toggle("is-on", v.id === id); });
    }
    function makeThumb(view, label, ic) {
      var b = document.createElement("button");
      b.className = "shop__thumb"; b.type = "button";
      b.setAttribute("data-view", view);
      b.innerHTML = '<span class="shop__thumb__ic">' + ic + '</span><span>' + label + '</span>';
      return b;
    }
    // Build the gallery from the active product's images. No images → just the pouch.
    function buildGallery() {
      if (!stageEl || !thumbsEl) return;
      var f = activeFlavor();
      $$(".shop__view--photo", stageEl).forEach(function (v) { v.remove(); });
      thumbsEl.innerHTML = "";
      var gal = (f.gallery || []).filter(Boolean);
      if (!gal.length) { thumbsEl.hidden = true; setView("viewFront"); return; }
      var zoomBtn = $("#shopZoom", stageEl);
      gal.forEach(function (src, i) {
        var v = document.createElement("div");
        v.className = "shop__view shop__view--photo";
        v.id = "viewPhoto" + i;
        v.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
        if (zoomBtn) stageEl.insertBefore(v, zoomBtn); else stageEl.appendChild(v);
        thumbsEl.appendChild(makeThumb("viewPhoto" + i, GAL_LABELS[i] || ("Photo " + (i + 1)), GAL_ICONS[i] || GAL_ICON_DEFAULT));
      });
      thumbsEl.hidden = false;
      setView("viewPhoto0");
    }
    if (thumbsEl) thumbsEl.addEventListener("click", function (e) {
      var t = e.target.closest(".shop__thumb");
      if (t) setView(t.getAttribute("data-view"));
    });
    var lb = $("#lightbox", box) || $("#lightbox");
    var lbStage = lb && $("#lbStage", lb);
    var lbCap = lb && $("#lbCap", lb);
    function openLightbox() {
      if (!lb || !lbStage) return;
      var active = $(".shop__thumb.is-on", box);
      var viewId = active ? active.getAttribute("data-view") : "viewFront";
      lbStage.innerHTML = "";
      if (viewId === "viewFront") {
        var blob = document.createElement("div");
        blob.className = "blob";
        if (blobEl) blob.style.background = blobEl.style.background;
        lbStage.appendChild(blob);
        var wrap = document.createElement("div");
        wrap.className = "lightbox__pouches" + (shopPouch.classList.contains("is-duo") ? " is-duo" : "");
        $$("img", shopPouch).forEach(function (im) { wrap.appendChild(im.cloneNode()); });
        lbStage.appendChild(wrap);
        if (lbCap) lbCap.textContent = titleEl ? titleEl.textContent : "";
      } else {
        var im = $("#" + viewId + " img", box);
        if (im) lbStage.appendChild(im.cloneNode());
        if (lbCap) lbCap.textContent = active ? active.querySelector("span:last-child").textContent + " photo" : "Photo";
      }
      lb.classList.add("show");
      document.body.style.overflow = "hidden";
    }
    function closeLightbox() { if (lb) { lb.classList.remove("show"); document.body.style.overflow = ""; } }
    var zoomBtn = $("#shopZoom", box);
    if (zoomBtn) zoomBtn.addEventListener("click", openLightbox);
    if (lb && !lb.__omwBound) {
      lb.__omwBound = true;
      lb.addEventListener("click", function (e) { if (e.target === lb || e.target.closest("#lbClose")) closeLightbox(); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeLightbox(); });
    }

    setFlavor(0);
  }

  /* ---- Cart button (no drawer): go to cart, or nudge if empty ---- */
  var cartBtn = $("#cartBtn");
  if (cartBtn && cartBtn.tagName !== "A") {
    cartBtn.addEventListener("click", function () {
      window.location.href = (OMW.routes && OMW.routes.cart) ? OMW.routes.cart : "/cart";
    });
  }

  /* ---- Scroll reveal ---- */
  // In the theme editor (designMode) sections are injected after load and the
  // observer never sees them, so reveal everything immediately there.
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io = (!designMode && "IntersectionObserver" in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" })
    : null;

  function setupReveals(root) {
    var els = $$(".reveal:not(.in)", root && root.querySelectorAll ? root : document);
    els.forEach(function (el, i) {
      if (io) { el.style.transitionDelay = (i % 4) * 60 + "ms"; io.observe(el); }
      else { el.classList.add("in"); }   // designMode or no IO: show now
    });
    // Safety net: if the observer never fires (e.g. element off-screen in an
    // odd layout), reveal anything still hidden shortly after.
    if (io) setTimeout(function () { $$(".reveal:not(.in)", document).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("in");
    }); }, 1200);
  }

  /* ---- init ---- */
  /* ---- Ways-to-squeeze photo carousel ---- */
  function initCarousel(root) {
    var scope = (root && root.querySelector) ? root : document;
    var track = scope.querySelector("#useTrack") || document.querySelector("#useTrack");
    if (!track || track.__omwCar) return;
    track.__omwCar = true;
    var slides = $$(".use-slide", track);
    if (!slides.length) return;
    var car = track.closest(".use-carousel") || document;
    var dotsWrap = car.querySelector("#useDots");
    var current = 0, autoTimer;
    function step() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    }
    function updateDots() {
      if (dotsWrap) $$("button", dotsWrap).forEach(function (d, i) { d.classList.toggle("is-on", i === current); });
    }
    function go(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: step() * current, behavior: "smooth" });
      updateDots();
    }
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      slides.forEach(function (_, i) {
        var b = document.createElement("button");
        b.type = "button"; b.setAttribute("aria-label", "Go to slide " + (i + 1));
        b.addEventListener("click", function () { go(i); restart(); });
        dotsWrap.appendChild(b);
      });
    }
    updateDots();
    var prevBtn = car.querySelector("#usePrev"), nextBtn = car.querySelector("#useNext");
    if (prevBtn) prevBtn.addEventListener("click", function () { go(current - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener("click", function () { go(current + 1); restart(); });
    var scrollT;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () { current = Math.round(track.scrollLeft / step()); updateDots(); }, 90);
    });
    function start() { if (slides.length > 1 && !designMode) autoTimer = setInterval(function () { go(current + 1); }, 4500); }
    function stop() { clearInterval(autoTimer); }
    function restart() { stop(); start(); }
    track.addEventListener("mouseenter", stop);
    track.addEventListener("mouseleave", start);
    start();
  }

  function init(root) { setupReveals(root); initBuybox(root); initCarousel(root); }
  if (document.readyState !== "loading") init(document);
  else document.addEventListener("DOMContentLoaded", function () { init(document); });

  // Shopify theme editor: re-init when a section is added/reordered/selected.
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:select", function (e) { setupReveals(e.target); });
})();
